import { DoorLoopConnectForm } from './DoorLoopConnectForm'
import type { VendorConnectorProps } from './types'

export function DoorLoopConnector({ onConnected }: VendorConnectorProps) {
  return <DoorLoopConnectForm onConnected={() => onConnected?.()} />
}
